import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AdminResponse, normalizeAdminError, unwrapAdminResponse } from './admin-api';

@Injectable({ providedIn: 'root' })
export class AdminHttpClient {
  private readonly http = inject(HttpClient);

  get<T>(path: string, params?: HttpParams): Observable<T> {
    return this.request(this.http.get<AdminResponse<T>>(this.url(path), { params }));
  }

  post<T>(path: string, body: unknown, withCredentials = false, headers?: HttpHeaders): Observable<T> {
    return this.request(this.http.post<AdminResponse<T>>(this.url(path), body, { withCredentials, headers }));
  }

  private request<T>(source: Observable<AdminResponse<T>>): Observable<T> {
    return source.pipe(
      map(unwrapAdminResponse),
      catchError(error => throwError(() => normalizeAdminError(error))),
    );
  }

  private url(path: string): string {
    return `${environment.apiUrl}${path.startsWith('/') ? path : `/${path}`}`;
  }
}
